<template>
  <div class="wrapper  box_v">
    <!--头部-->
    <page-head
      title="预约办理"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    >
      <div slot class="box tab-wrapper">
        <div class="tab-btn active">预约记录</div>
        <div
          class="tab-btn"
          @click="$router.replace({ name: 'appointmentService' })"
        >
          服务项目
        </div>
        <!-- <div class="tab-btn" @click="$router.replace({name:'blacklist'})">黑名单</div> -->
      </div>
    </page-head>
    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <i-form ref="formInline" inline label-position="top">
          <row :gutter="80">
            <i-col span="6">
              <FormItem label="预约人" prop="host">
                <Input v-model="appointmentPeople" />
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="联系电话" prop="host">
                <Input v-model="appointmentPhone" />
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="事项类型" prop="host">
                <Select v-model="eventTypeId" @on-change="typeChange">
                  <Option
                    v-for="(item, index) in eventTypeList"
                    :value="item.id"
                    :key="index"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="事项名称" prop="host">
                <Select v-model="eventNameId">
                  <Option
                    v-for="(item, index) in selectType.children"
                    :value="item.id"
                    :key="index"
                    >{{ item.name }}
                  </Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="预约日期" prop="host">
                <DatePicker type="date" v-model="appointmentDate"></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="预约时间" prop="host">
                <TimePicker
                  v-model="appointmentTime"
                  type="timerange"
                ></TimePicker>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem label="办理状态" prop="host">
                <Select v-model="banliStatus">
                  <Option
                    v-for="item in statusList"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </i-col>
            <i-col span="3">
              <FormItem label="预约起始日期" prop="host">
                <DatePicker
                  type="date"
                  v-model="appointmentBeginDate"
                ></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="3">
              <FormItem label="预约结束日期" prop="host">
                <DatePicker
                  type="date"
                  v-model="appointmentEndDate"
                ></DatePicker>
              </FormItem>
            </i-col>
          </row>
        </i-form>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-wrapper">
          <div class="head-btn-wrapper">
            <Button
              v-for="(item, index) in headBtn"
              class="bkcc-btn"
              @click="handleBtn(item.type)"
              >{{ item.name }}
            </Button>
          </div>
          <Table
            border
            :columns="settingColumn"
            :data="appointmentList"
            :loading="isTableLoading"
            @on-select="selectTableItem"
            @on-select-cancel="cancelTableItem"
          ></Table>
          <page
            :total="total"
            @on-change="pageChange"
            class="page"
            :page-size="rows"
            :current="page"
            show-total
          />
        </div>
      </Card>
    </div>

    <opinion-modal
      :show-modal="showOpinion"
      @closeOpinion="showOpinion = false"
      @confirmCancel="confirmCancel"
    ></opinion-modal>
    <detail-modal
      :show-modal="showDetail"
      @closeOpinion="showDetail = false"
      :id="showItemId"
    ></detail-modal>
  </div>
</template>

<script>
import pageHead from "../../components/head";
import opinionModal from "./appointComponents/opinionModal";
import detailModal from "./appointComponents/detailModal";
var that;
export default {
  name: "appointmentRecord",
  components: {
    pageHead,
    opinionModal,
    detailModal
  },
  data() {
    return {
      eventTypeList: [],
      page: 1,
      rows: 7,
      eventTypeId: "", // 预约事件类型ID,
      eventNameId: "", //预约事件名称ID,
      selectType: {},
      btnList: [
        {
          name: "搜索",
          type: "search",
          loading: false
        },
        {
          name: "重置",
          type: "init",
          loading: false,
          btnType: "default"
        },
        {
          name: "导出",
          type: "upload",
          loading: false,
          btnType: "default"
        }
      ],
      appointmentPeople: "",
      appointmentPhone: "",
      appointmentDate: "",
      appointmentTime: [],
      appointmentBeginDate: "",
      appointmentEndDate: "",
      banliStatus: "",
      statusList: [
        {
          label: "已预约",
          value: 1,
          color: "#00d372"
        },
        {
          label: "逾期未办",
          value: 2,
          color: "#5e6d9e"
        },
        {
          label: "居民取消办理",
          value: 4,
          color: "#cfc800"
        },
        {
          label: "管理员取消预约",
          value: 8,
          color: "#cf6aff"
        },
        {
          label: "待评价",
          value: 16,
          color: "#ffaf00"
        },
        {
          label: "已办结",
          value: 32,
          color: "#8cc64e"
        }
      ],
      isTableLoading: false,
      appointmentList: [],
      settingColumn: [
        {
          type: "selection",
          width: 70,
          align: "center"
        },
        {
          title: "预约人",
          // key: "name",
          align: "center",
          width: 105,
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {},
                that.appointmentList[params.index].name
                  ? that.appointmentList[params.index].name
                  : that.appointmentList[params.index].userName
              )
            ]);
          }
        },
        {
          title: "联系电话",
          key: "phone"
          // width: 180
        },
        {
          title: "身份证号",
          key: "cardNO"
          // width: 220
        },
        {
          title: "预约日期",
          key: "appointmentDate"
        },
        {
          title: "预约时间",
          key: "appointmentTime"
        },
        {
          title: "事项类型",
          key: "eventType"
        },
        {
          title: "事项名称",
          key: "eventName"
        },
        {
          title: "办理状态",
          // width: 200,
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: that.statusList.filter(
                      item =>
                        item.value == that.appointmentList[params.index].status
                    )[0].color,
                    display:
                      that.appointmentList[params.index].status == 32
                        ? "none"
                        : ""
                  }
                },
                that.appointmentList[params.index].statusName
              ),
              h("Rate", {
                style: {
                  display:
                    that.appointmentList[params.index].status == 32
                      ? ""
                      : "none"
                },
                attrs: {
                  disabled: true,
                  allowHalf: true,
                  value: that.appointmentList[params.index].score
                }
              })
            ]);
          }
        },
        {
          title: "操作",
          // width: 240,
          render: function(h, params) {
            var status = that.appointmentList[params.index].status;
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    display: status == 1 || status == 2 ? "" : "none",
                    marginRight: "10px"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.selectPeople = that.appointmentList[params.index].id;
                      that.showOpinion = true;
                    }
                  }
                },
                "[取消预约]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginRight: "10px",
                    display: status == 1 || status == 2 ? "" : "none"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.changeUserAppointment(
                        that.appointmentList[params.index].id,
                        16
                      );
                    }
                  }
                },
                "[办理]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    display: status == 1 || status == 2 ? "none" : ""
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.showItemId = that.appointmentList[params.index].id;
                      that.showDetail = true;
                    }
                  }
                },
                "[查看办理信息]"
              )
            ]);
          }
        }
      ],
      headBtn: [
        {
          name: "取消预约",
          type: "cancel",
          loading: false
        },
        {
          name: "办理",
          type: "banli",
          loading: false
        }
      ],
      selectAppointment: [],
      showOpinion: false,
      selectPeople: "",
      showItemId: "",
      showDetail: false,
      total: 0
    };
  },
  methods: {
    // 获取大类等信息
    getEventType() {
      this.$get(this.urlobj.dictionaryList("appointment")).then(res => {
        this.eventTypeList = res.rows.map(item => {
          return {
            id: item.id,
            name: item.dicName,
            children: item.children.map(_item => {
              var remark;
              try {
                remark = JSON.parse(_item.remark).attachment;
              } catch (e) {
                remark = _item.remark;
              }
              return {
                name: _item.dicName,
                id: _item.id,
                pic: _item.headPicUrl,
                remark
              };
            })
          };
        });
      });
    },
    //选择了大类  回显对应信息
    typeChange(val) {
      //小类清空
      this.eventNameId = "";
      this.eventTypeList.forEach((item, index) => {
        if (item.id == val) {
          this.selectType = item;
        }
      });
    },
    handleBtn(type) {
      if (type == "search") {
        this.initAppointmentUser();
      } else if (type == "init") {
        this.eventTypeId = "";
        this.eventNameId = "";
        this.appointmentPeople = "";
        this.appointmentPhone = "";
        this.appointmentDate = "";
        this.appointmentTime = [];
        this.appointmentBeginDate = "";
        this.appointmentEndDate = "";
        this.banliStatus = "";
        this.selectType = {};
        this.initAppointmentUser();
      } else if (type == "banli") {
        if (!this.selectAppointment.length) {
          this.$Message.warning("未选择人员");
          return;
        }
        var idList = this.selectAppointment.map(item => item.id).join(",");
        this.changeUserAppointment(idList, 16);
      } else if (type == "cancel") {
        if (!this.selectAppointment.length) {
          this.$Message.warning("未选择人员");
          return;
        }
        this.selectPeople = "";
        this.showOpinion = true;
      } else if (type == "upload") {
        this.uploadAppointmentUser();
      }
    },
    initAppointmentUser() {
      this.page = 1;
      this.getAppointmentUser();
    },
    getAppointmentUser() {
      this.isTableLoading = true;
      let {
        page,
        rows,
        eventTypeId,
        eventNameId,
        appointmentDate,
        banliStatus,
        appointmentPeople,
        appointmentPhone,
        appointmentTime,
        appointmentBeginDate,
        appointmentEndDate
      } = this;
      // console.log(appointmentTime)
      var appointmentBeginTime = "",
        appointmentEndTime = "";
      if (appointmentTime.length) {
        appointmentBeginTime = appointmentTime[0];
        appointmentEndTime = appointmentTime[1];
      }
      if (appointmentBeginDate > appointmentEndDate) {
        this.$Message.error("起始时间要小于结束时间");
        this.isTableLoading = false;
      } else {
        this.$post(this.urlobj.getAppointmentUser, {
          pageNum: page,
          pageSize: rows,
          eventTypeId,
          eventNameId,
          appointmentDate: appointmentDate
            ? this.$util.FormatDate(new Date(appointmentDate), "yyyy-MM-dd")
            : "",
          appointmentBeginTime,
          appointmentEndTime,
          status: banliStatus,
          userName: appointmentPeople,
          phoneNO: appointmentPhone,
          appointmentBeginDate: appointmentBeginDate
            ? this.$util.FormatDate(
                new Date(appointmentBeginDate),
                "yyyy-MM-dd"
              )
            : "",
          appointmentEndDate: appointmentEndDate
            ? this.$util.FormatDate(new Date(appointmentEndDate), "yyyy-MM-dd")
            : ""
        }).then(res => {
          this.isTableLoading = false;
          this.total = res.total;
          this.appointmentList = res.rows.map(item => {
            var _checked = false;
            this.selectAppointment.forEach(_item => {
              if (_item.id == item.id) {
                _checked = true;
              }
            });
            return {
              id: item.id,
              name: item.realName,
              userName: item.userName,
              phone: item.phoneNO,
              cardNO: item.idCardNO,
              appointmentDate: item.appointmentDate,
              appointmentTime:
                item.appointmentBeginTime.slice(0, 5) +
                "-" +
                item.appointmentEndTime.slice(0, 5),
              eventType: item.eventType,
              eventName: item.eventName,
              status: item.status,
              statusName: this.statusList.filter(
                _item => _item.value == item.status
              )[0].label,
              _checked,
              score: item.score ? parseFloat((item.score / 100).toFixed(1)) : 5
            };
          });
        });
      }
    },
    confirmCancel(reason) {
      var idList;
      if (this.selectPeople) idList = this.selectPeople;
      else idList = this.selectAppointment.map(item => item.id).join(",");
      this.changeUserAppointment(idList, 8, reason);
    },
    changeUserAppointment(idList, status, cancelMsg = "") {
      this.$post(this.urlobj.changeUserAppointment, {
        idList,
        status,
        cancelMsg
      })
        .then(res => {
          this.$Message.success("操作成功");
          this.showOpinion = false;
          this.getAppointmentUser();
        })
        .catch(e => {});
    },
    pageChange(val) {
      this.page = val;
      this.getAppointmentUser();
    },
    selectTableItem(value) {
      this.selectAppointment = this._.unionBy(
        this.selectAppointment,
        value,
        "id"
      );
    },
    cancelTableItem() {
      var value = arguments[1];
      var delIndex;
      this.selectAppointment.forEach((item, index) => {
        if (item.id == value.id) delIndex = index;
      });
      this.selectAppointment.splice(delIndex, 1);
    },
    uploadAppointmentUser() {
      let {
        eventTypeId,
        eventNameId,
        appointmentDate,
        appointmentTime,
        banliStatus,
        appointmentPeople,
        appointmentPhone,
        appointmentBeginDate,
        appointmentEndDate
      } = this;
      var appointmentBeginTime = "",
        appointmentEndTime = "";
      if (appointmentTime.length) {
        appointmentBeginTime = appointmentTime[0];
        appointmentEndTime = appointmentTime[1];
      }
      var url = this.urlobj.uploadAppointmentUser;
      if (appointmentBeginDate > appointmentEndDate) {
        this.$Message.error("起始时间要小于结束时间");
      } else {
        url =
          url +
          "?communityId=" +
          this.$store.state.streetorcommunityid +
          "&eventTypeId=" +
          eventTypeId +
          "&eventNameId=" +
          eventNameId +
          "&appointmentDate=" +
          (appointmentDate
            ? this.$util.FormatDate(appointmentDate, "yyyy-MM-dd")
            : "") +
          "&appointmentBeginDate=" +
          (appointmentBeginDate
            ? this.$util.FormatDate(appointmentBeginDate, "yyyy-MM-dd")
            : "") +
          "&appointmentEndDate=" +
          (appointmentEndDate
            ? this.$util.FormatDate(appointmentEndDate, "yyyy-MM-dd")
            : "") +
          "&appointmentBeginTime=" +
          appointmentBeginTime +
          "&appointmentEndTime=" +
          appointmentEndTime +
          "&status=" +
          banliStatus +
          "&userName=" +
          appointmentPeople +
          "&phoneNO=" +
          appointmentPhone +
          "&token=" +
          this.$store.state.access_token;
        console.log(
          url,
          appointmentDate,
          appointmentBeginDate,
          appointmentEndDate
        );
        window.open(url);
      }
    }
  },
  mounted() {
    that = this;
    this.getEventType();
    this.getAppointmentUser();
  }
};
</script>

<style scoped lang="less">
/deep/ .ivu-card-body {
  height: 100%;
}
/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

/deep/ .ivu-form-inline .ivu-form-item {
  display: block;
}

/deep/ .ivu-date-picker {
  display: block;
}

.wrapper {
  height: 100%;
}

.tab-wrapper {
  position: absolute;
  left: 20px;
  .tab-btn {
    height: 30px;
    line-height: 30px;
    width: 85px;
    text-align: center;
    background: #fff;
    color: #999;
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .active {
    background: #ff7b44;
    color: #fff;
  }
}

.nodata-card {
  margin: 0 20px 20px;
  align-items: center;
  justify-content: center;
  img {
    height: 280px;
    width: 390px;
  }
  .text {
    font-size: 15px;
    color: #ff7744;
    line-height: 1;
    padding: 25px 0 30px;
    letter-spacing: 10px;
    text-align: center;
  }
  .btn {
    min-width: 60px;
    height: 28px;
    line-height: 13px;
    display: block;
    margin: auto;
  }
}

.card-box {
  margin: 0 20px 20px;
}
.head-btn-wrapper {
  margin-left: auto;
  width: fit-content;
  margin-bottom: 20px;
}
.table-wrapper {
  height: 100%;
  position: relative;
  padding: 20px 20px 80px;
}
.page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
